import StorageUtils from '@spothero/utils/storage';
import { v4 as uuidV4, validate } from 'uuid';
import { StorageDurations, StorageKeys, StorageTypes, } from 'common/constants/storageKeys';
export const NEW_VISITOR = 'n';
export const RETURNING_VISITOR = 'r';
export const _formatUserId = (userId) => {
    if (typeof userId !== 'string' || userId.length === 0) {
        return undefined;
    }
    // Remove all double quotes regardless of position
    const value = userId.replace(/"/g, '');
    if (!validate(value)) {
        return undefined;
    }
    return value;
};
export const _getCookie = (cookieName, options) => {
    if (!options?.req) {
        throw new Error('Request and response objects are required for cookie operations');
    }
    const { req } = options;
    const cookies = req.cookies || {};
    return cookies[cookieName] || undefined;
};
export const _getServerCookieName = (cookieName) => {
    return `${cookieName}-s`; // Append '-s' to indicate a server-side cookie
};
export const _getServerCookie = (cookieName, options) => {
    const serverCookieName = _getServerCookieName(cookieName);
    return _getCookie(serverCookieName, options);
};
/**
 * Populates both server-side and client-side cookies with the given value.
 * This allows us to work around the Intelligent Tracking Prevention restrictions
 * Reference: https://support.optimizely.com/hc/en-us/articles/4410284274573-Intelligent-Tracking-Prevention#h_01HH2YWSS476N0Y1VEHJ8NMCXV
 */
export const _setCookieForServerAndClient = (cookieName, value, options) => {
    if (!options?.res) {
        throw new Error('Response object is required for cookie operations');
    }
    if (typeof value !== 'string') {
        throw new Error('Cookie value must be a string');
    }
    const serverCookieName = _getServerCookieName(cookieName);
    const { res } = options;
    // Client-side cookie
    res.cookie(cookieName, value, {
        maxAge: StorageDurations.YEAR_IN_MILLISECONDS,
    });
    // Server-side cookie
    res.cookie(serverCookieName, value, {
        maxAge: StorageDurations.YEAR_IN_MILLISECONDS,
        httpOnly: true,
    });
};
export const getWebExperimentCookieOnServer = ({ req, res, }) => {
    const optimizelyUserIdCookieValue = _getServerCookie(StorageKeys.EXPERIMENTID, { req }) ??
        _getCookie(StorageKeys.EXPERIMENTID, { req }) ??
        '';
    const optimizelyUserId = _formatUserId(optimizelyUserIdCookieValue) || uuidV4();
    _setCookieForServerAndClient(StorageKeys.EXPERIMENTID, optimizelyUserId, {
        res,
    });
    return optimizelyUserId;
};
export const getWebExperimentCookie = () => {
    const shExperimentCookie = StorageUtils.get(StorageKeys.EXPERIMENTID, StorageTypes.COOKIE);
    const optimizelyUserId = _formatUserId(shExperimentCookie);
    if (typeof optimizelyUserId === 'string' && optimizelyUserId?.length > 0) {
        return optimizelyUserId;
    }
    return '';
};
